import { httpDelete, post } from "@readai/common/api";
import type { CreateSessionTagBody, Tag } from "@readai/common/types";
import { withQueryParamsUrl } from "@readai/common/utils";

/**
 * Creates a link between a tag and a session. Will create a new tag in the BE if the tag
 * does not already exist.
 * @returns void (201 Created)
 * */
export const createSessionTag = (
  sessionId: string,
  body: CreateSessionTagBody,
) => {
  return post(`/sessions/${sessionId}/tags`, body, { withCreds: true });
};

/**
 * Removes the link between a session and a tag.
 * @returns void (204 No Content)
 * */
export const removeSessionTag = (
  sessionId: string,
  tagId: Tag["id"],
  applyToSeries?: boolean,
) => {
  const url = withQueryParamsUrl(`/sessions/${sessionId}/tags/${tagId}`, {
    apply_to_series: applyToSeries,
  });
  return httpDelete(url, {
    withCreds: true,
  });
};
